import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const TermsAndConditionsDialog = ({ open, onClose }) => {
  return (
    <Dialog maxWidth="md" open={open} onClose={onClose}>
      <DialogTitle>Terms and Conditions</DialogTitle>
      <DialogContent>
        <h3>
          I understand that local anesthetic, antibiotics, analgesics and other medications can
          cause allergic reactions causing redness and swelling of tissue, pain, itching, vomiting,
          and/or anaphylactic shock.
        </h3>
        <h4>CONSENT</h4>
        <p>
          I understand that dentistry is not an exact science and that therefore, reputable
          practitioners cannot properly guarantee results. I acknowledge that no guarantee or
          assurance has been made by anyone regarding the dental treatment which I have requested
          and authorized. I understand that treatment plan and fees proposed are subject to
          modification, depending upon unforeseen or undiagnosed conditions that may be recognized
          only during the course of treatment. I hereby authorize any of the doctors or dental
          auxiliaries to proceed with and perform the dental restorations and treatments as
          explained to me. I understand that this is only an estimate and subject to modification
          depending on unforeseen or diagnosable circumstances that may arise during the course of
          treatment. I understand that regardless of any dental insurance coverage I may have. I am
          responsible for payment of the dental fees. I have been explained the need, process,
          advantages, alternate procedures, possible complications of the treatment and am giving my
          full consent to undergo treatment above mentioned.
        </p>
      </DialogContent>
      <Button onClick={onClose} style={{ color: '#66b5a3' }}>
        Close
      </Button>
    </Dialog>
  );
};

export default TermsAndConditionsDialog;
